import { ModuleFE_FHIRResourceSubtype } from './ModuleFE_FHIRResourceSubtype.js';
export const ModulePackFE_FHIRResourceSubtypeDB = [ModuleFE_FHIRResourceSubtype];
//# sourceMappingURL=module-pack.js.map